import { render, staticRenderFns } from "./Exhibitors.vue?vue&type=template&id=08b61ccc&scoped=true&"
import script from "./Exhibitors.vue?vue&type=script&lang=js&"
export * from "./Exhibitors.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitors.vue?vue&type=style&index=0&id=08b61ccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b61ccc",
  null
  
)

export default component.exports